import { render } from "./ManualPengguna.vue?vue&type=template&id=6bdaa1c2"
import script from "./ManualPengguna.vue?vue&type=script&lang=js"
export * from "./ManualPengguna.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__